import * as React from 'react'
import classNames from 'classnames'

import { Content } from 'sdk/components'
import { useWindowSize } from 'core/hooks/useWindowSize'
import { Text, TextName } from '../../text/Text'
import { Pill } from '../../pill/Pill'

import classes from './HeroRedesign.module.scss'

interface ComponentProps {
  imageDesktop: string
  imageTablet: string
  imageMobile: string
  pillText?: string
  pillIcon?: string
  titleText: string
  description: React.ReactNode
  className?: string
  alwaysCentered?: boolean
}

export const HeroRedesign: React.FC<ComponentProps> = (props) => {
  const { imageDesktop, imageTablet, imageMobile, pillText, pillIcon, titleText, description, className, alwaysCentered } = props
  const { width } = useWindowSize()

  const currentImage =
    width <= 640 ? imageMobile :
    width <= 1024 ? imageTablet :
    imageDesktop

  return (
    <Content
      className={classNames(classes.container, { [classes.alwaysCentered]: alwaysCentered }, className)}
      image={currentImage}
      imageClassName={classes.backgroundImage}
      gap={25}
    >
      <div className={classes.contentWrapper}>
        {pillText && pillIcon && (
          <Pill
            text={pillText}
            icon={pillIcon}
            variant="gradient"
          />
        )}

        <Text
          type={TextName.H1}
          className={classes.title}
        >
          {titleText}
        </Text>

        <Text
          type={TextName.Text}
          className={classes.description}
        >
          {description}
        </Text>
      </div>
    </Content>
  )
}
